module.exports = __webpack_public_path__ + "static/img/food (2).d9f7714.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/restaurant/food (2).jpg
// module id = HDAD
// module chunks = 1